<template>
  <div class="searchBarNode" id="searchDiv" :class="{export: isExport}">
    <el-form v-if="positRedact">
      <el-form-item style="position: relative;">
        <el-cascader
          clearable
          v-model="recruitClassNumber"
          :options="recruitList"
          @change="postMes"
          ref="post"
          class="salary-selsect-post"
          :placeholder="userInfo.user_nature == 1 ? language.liveClass2 : language.liveClass1"
          style="margin-right: 20px;">
        </el-cascader>
        <el-input
            v-model="locationName"
            :readonly="true"
            v-on:click.native="showArea"
            @mouseover.native="handleOver($event)"
            @mouseout.native="handleOut($event)"
            class="salary-selsect-post"
            :placeholder="userInfo.user_nature == 1 ? language.guestsLocation2 : language.guestsLocation1"
            ref="wordLocation"
            style="margin-right: 20px;">
        </el-input>
        <i :class="jiantou"
           @mouseover="handleOver1($event)"
           @click="clearCity"
           style="width: 20px;height: 20px; position: absolute;left: 518px;top:13px;font-size: 14px;color: #C0C4CC"></i>
        <el-select
            clearable
            class="salary-selsect-post"
            v-model="salaryNumber"
            :placeholder="language.salaryRange"
            ref="salary"
            style="margin-right: 20px;"
        >
            <el-option
                v-for="item in salaryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >

            </el-option>
        </el-select>
        <el-button
            class="searchBtn"
            @click.native="search"
            style="width: 110px;">
          <span style="color: #fff;font-size: 16px;">{{ lan=="ch"?"搜索":"Search" }}</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--订单管理-->
    <el-form class="order" v-else-if="orderManage">
      <el-form-item>
        <span :class="chance1" @click="all">全部</span>
        <span :class="chance2" @click="awaitPay">待付款</span>
        <span :class="chance3" @click="ok">已完成</span>
        <el-input
            style="width: 500px;border-radius: 5px;margin-right:10px;overflow:hidden;border: solid 1px #cccccc;"
            v-model="ticName"
            type="text"
            :placeholder="language.ticName"
            ref="tickName"
        ></el-input>
        <el-button
            class="searchBtn"
            @click.native="searchFair"
            style="width: 80px;position: relative;top: -15px;"
        >
          <!-- <svg-icon icon-class="searchs" style="width: 25px;height: 25px;line-height: 40px" /> -->

          <span style="color: #fff;font-size: 16px;">{{ lan=="ch"?"搜索":"Search" }}</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--直播间管理-->
    <el-form v-else-if="broadcastTrue">
      <el-form-item>
        <!--展会状态-->
        <el-select
            clearable
            class="salary-selsect"
            :placeholder="language.exhibitionState"
            v-model="exhibitionState"
            style="width: 262px;border-radius: 5px;margin-right:10px;overflow:hidden;background-color: #FFFFFF;border: solid 1px #cccccc;"
        >
          <el-option
              v-for="item in selectType"
              :key="item.type"
              :label="item.name"
              :value="item.type"
          ></el-option>
        </el-select>
        <!--招聘会名称-->
        <el-select
            clearable
            class="salary-selsect"
            :placeholder="language.ticName"
            v-model="jobFairName"
            style="width: 262px;border-radius: 5px;margin-right:10px;overflow:hidden;background-color: #FFFFFF;border: solid 1px #cccccc;"
        >
          <el-option
              v-for="item in exh_list"
              :key="item.exhibition_id"
              :label="item.exh_name"
              :value="item.exhibition_id"
          ></el-option>
        </el-select>
        <!--直播间名称/展会名称-->
        <el-input
            clearable
            style="width: 295px;border-radius: 5px;margin-right:10px;overflow:hidden;border: solid 1px #cccccc;"
            v-model="dirExhName"
            type="text"
            :placeholder="language.directExhName"
        ></el-input>
        <el-button
            class="searchBtn"
            @click.native="search"
            style="width: 100px;float: right;"
        >
          <!-- <svg-icon icon-class="searchs" style="width: 25px;height: 25px;line-height: 40px" /> -->

          <span style="color: #fff;font-size: 16px;">{{ lan=="ch"?"搜索":"Search" }}</span>
        </el-button>
      </el-form-item>
    </el-form>

    <!--面试记录-->
    <el-form
        :inline="true"
        label-width="auto"
        label-suffix=":"
        size="large"
        v-else-if="interview"
    >
      <el-form-item>
        <!--会议名称-->
        <el-select
            clearable
            style="width:263px;background:#fff;border: 1px solid #e6e6e6;margin-right:10px;border-radius: 5px; "
            v-model="exhibitionName"
            :placeholder="language.confernece"
            v-if="userInfo.user_nature == 1"
        >
          <el-option
              v-for="(item,index) in exh_list"
              :key="index"
              :label="item.exh_name"
              :value="index"
          ></el-option>
        </el-select>
        <!--展会状态-->
        <el-select
            clearable
            style="width:263px;background:#fff;border: 1px solid #e6e6e6;margin-right:10px;border-radius: 5px; "
            v-model="exhibitionState"
            :placeholder="language.exhibitionState"
            v-if="userInfo.user_nature == 3"
        >
          <el-option
              v-for="item in selectType"
              :key="item.type"
              :label="item.name"
              :value="item.type"
          ></el-option>
        </el-select>
        <el-input
            clearable
            :placeholder="searchInputPlc"
            v-model="companyName"
            class="input-with-interview"
            style="margin-right:10px;border-radius: 5px;width: auto;"
        >
        </el-input>
        <el-button
            class="searchBtn"
            @click.native="search"
            style="width: 100px;"
        >
          <span style="color: #fff;font-size: 16px;">{{ lan=="ch"?"搜索":"Search" }}</span>
        </el-button>
        <!--        <el-button v-if="isExport" @click="exportListClick">{{lan=='ch'?'导出列表':'Export list'}}</el-button>-->
      </el-form-item>
    </el-form>

    <!--门票管理-->
    <el-form
        :inline="true"
        label-width="auto"
        label-suffix=":"
        size="large"
        v-else
    >
      <el-form-item>
        <el-select
          clearable
          style="width:263px;background:#fff;border: 1px solid #e6e6e6;margin-right:10px;border-radius: 5px; "
          v-model="exhibitionState"
          placeholder="展会状态"
          v-if="!isShow">
          <el-option
          v-for="item in selectType"
          :key="item.type"
          :label="item.name"
          :value="item.type"></el-option>
        </el-select>
          <el-input
              :placeholder="searchInputPlc"
              v-model="exhibitionName"
              class="input-with-select"
              style="margin-right:10px;border-radius: 5px;width: auto;"
          >
          </el-input>
        <el-button
          class="searchBtn"
          @click.native="search"
          style="width: 100px;"
          >
          <!-- <svg-icon icon-class="searchs" style="width: 25px;height: 25px;line-height: 40px" /> -->
          <span style="color: #fff;font-size: 16px;">{{ lan=="ch"?"搜索":"Search" }}</span>
          </el-button>


      </el-form-item>
    </el-form>

    <!--所在城市-->
    <area-div v-model="areaName" :areaEl="areaEl" :visible.sync="areaVisible" @areaVisibleEvent="areaVisibleEvent" parentId="searchDiv" :offsetLeft="190"/>
  </div>
</template>
<script>
import { language } from "../../../../language/get";
import Cookies from "../../../../common/cookie";
import {
  GzRecordExport,
  CzRecordExport,
  SubscribeGzExport
} from "@/api/export";
import areaDiv from  "@/components/area/index";
import {selectRecruitPost} from "@/api/exhibition";
import {getMyExhibition} from "@/api/btManage";
import {mapGetters} from "vuex";

export default {
  components: {
    areaDiv
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  props: {
    selectType: {
      type: Array,
      default: () => {
        return [];
      },
    },
    searchInputPlc: {
      type: String,
      default: "",
    },
    searchSelectPlc: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isExport: {
      type: Boolean,
      default: false,
    },
    isExportFlag: {
      type: String,
      default: "",
    },
    positRedact: {
      type:Boolean,
      default:false
    },
    orderManage: {
      type:Boolean,
      default:false
    },
    broadcastTrue: {
      type:Boolean,
      default:false
    },
    userInfoId: {
      type:String,
      default:""
    },
    interview: {
      type:Boolean,
      default:false
    },

  },
  data() {
    return {
      jiantou:"el-icon-arrow-down",  //箭头
      tipsJob:"",
      language: language(),
      chance1:"chance1",
      chance2:"chance",
      chance3:"chance",
      status:'',
      exhibitionName: null,
      companyName:null,
      exhibitionState: null, //展会状态
      dirExhName:null, //直播间名称/展会状态
      lan:Cookies.get("lang"),
      recruitClassNumber:[], //招聘岗位下拉列表的值
      recruitList:[], //招聘岗位信息列表
      jobFairName:null, //招聘会名称
      areaVisible: false,
      areaName: '',
      areaEl: null,
      locationName: "", //招聘工作地
      salaryNumber:"",
      ticName:"",
      exh_list:[], //所有展会列表
      exhibition_id:"",
      salaryList:[
        {
          value:'1K-3K',
          label:"1K-3K"
        },{
          value:'3K-5K',
          label:"3K-5K"
        },{
          value:'5K-8K',
          label:"5K-8K"
        },{
          value:'8K-12K',
          label:"8K-12K"
        },{
          value:'12K以上',
          label:"12K以上"
        }
      ],
    };
  },
  watch: {
    exhibitionState: {
      handler() {
        // this.$emit(
        //   "changeExhibitionState",
        //   this.exhibitionState,
        //   this.exhibitionName
        // );
        // this.$emit("toSearch", this.exhibitionState, this.exhibitionName);
      },
      immediate: true,
    },
  },
  methods: {
    //鼠标移入事件
    handleOver(e) {
      console.log("移入" , e);
        if(this.$refs.wordLocation.value != undefined && this.locationName != "") {
          console.log(this.$refs.wordLocation);
          this.jiantou = "el-icon-circle-close";
        }else{
          this.jiantou = "el-icon-arrow-down";
        }

    },
    handleOver1(e) {
        if(this.$refs.wordLocation.value != undefined && this.locationName != "" && this.jiantou == "el-icon-arrow-down"){
          this.jiantou = "el-icon-circle-close"
        }else {
          this.jiantou = "el-icon-arrow-down"
        }

    },
    clearCity(){
        if(this.$refs.wordLocation.value != undefined || this.jiantou == "el-icon-circle-close") {
          // this.$refs.wordLocation.value = "";
          this.locationName = "";
        }

    },
    //鼠标移出事件
    handleOut(e) {
      if(this.areaVisible){
        this.jiantou = "el-icon-arrow-up";
      }else{
        this.jiantou = "el-icon-arrow-down";
      }

    },
    all(){
      this.chance1 = "chance1";
      this.chance2 = "chance";
      this.chance3 = "chance";
      this.status = '';
      this.searchFair();
    },
    awaitPay(){
      this.chance1 = "chance";
      this.chance2 = "chance1";
      this.chance3 = "chance";
      this.status = 0;
      this.searchFair();
    },
    ok(){
      this.chance1 = "chance";
      this.chance2 = "chance";
      this.chance3 = "chance1";
      this.status = 1;
      this.searchFair();
    },
    areaVisibleEvent(visible){
      this.areaVisible = visible;
      this.locationName = this.areaName;
      this.handleOut();
    },
    locationClearable(){
      this.locationName = '';
    },
    showArea(e){
      this.areaEl = e.target;
      this.areaVisible = true;

    },
    loadData(){
      //获取招聘岗位
      selectRecruitPost({ exhibition_id: this.exhibitionId }).then((res) => {
        if(res.type == 1){
          const data = res.data;
          // console.log("data：", data);
          for(var index in data) {
            if (data[index].super_id == null) {
              this.recruitList.push({
                value: data[index].id,
                label: data[index].name,
                children: []
              })
            }
          }
          for(var index in data){
            if(data[index].super_id != null){
              for(var i in this.recruitList){
                if(this.recruitList[i].value == data[index].super_id){
                  // this.$set(this.recruitList[i],"children",data[index])
                  this.recruitList[i].children.push({
                    value:data[index].id,
                    label:data[index].name,
                    super_id:data[index].super_id
                  })
                }
              }
            }
          }
        }else{
          return this.$message.error({ message: res.text, offset: 120 });
        }
      });

      if(this.broadcastTrue || this.interview) {
        //获取展会列表
        getMyExhibition({user_id: this.userInfoId, lan: this.lan}).then((res) =>  {
          let exh_list = res.data;
            exh_list.unshift({
              exh_name: "全部",
              exh_name_en: "ALL",
              exh_state: "",
              exhibition_id: ""
            });
            this.exh_list = exh_list;
            this.exhibition_id = "";
            // console.log("00000:" , this.exh_list);
        })
      }
    },
    postMes(value){
      this.jobValue = value;
    },
    exportListClick(){
      if(this.isExportFlag == "1"){
        this.gzSubscribeExport();
      }else if(this.isExportFlag == "2"){
        this.exportGzSubscribe();
      }else if(this.isExportFlag == "3"){
        this.exportCzSubscribe();
      }
    },
    //观展预约列表导出
    gzSubscribeExport(){
      const props = {
        exhibitionState:  this.exhibitionState,
        keyword:  this.exhibitionName,
        lan: this.lan
      }
      SubscribeGzExport(props).then(response => {
        const content = response;
        const blob = new Blob([content], {
          type: " application/vnd.ms-excel"
        });

        const fileName = "预约列表.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      }).catch(() => {});
    },
    //观展记录列表导出
    exportGzSubscribe(){
      const props = {
        keyword: this.exhibitionName,
        lan: this.lan
      }
      GzRecordExport(props).then(response => {
        const content = response;
        const blob = new Blob([content], {
          type: " application/vnd.ms-excel"
        });

        const fileName = "观展记录列表.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      }).catch(() => {});
    },
    //参展记录列表导出
    exportCzSubscribe(){
      const props = {
        keyword: this.exhibitionName,
        lan: this.lan
      }
      CzRecordExport(props).then(response => {
        const content = response;
        const blob = new Blob([content], {
          type: " application/vnd.ms-excel"
        });

        const fileName = "参展记录列表.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      }).catch(() => {});
    },
    search() {
      // debugger;
      if(this.positRedact){
        this.$emit("toSearch", {recruitClassNumber: this.recruitClassNumber, locationName: this.locationName,salaryNumber: this.salaryNumber});
      }else if(this.broadcastTrue){
        console.log(this.jobFairName + "  sssssssssssss");
         this.$emit("toSearch", this.exhibitionState, this.jobFairName, this.dirExhName);
      }else {
        console.log("门票管理");
        this.$emit("toSearch",this.exhibitionName, this.exhibitionState);
      }

    },
    searchFair() {
      this.$emit("toSearch", {status: this.status, name: this.ticName});
    },
    clear() {
      this.exhibitionState = null;
      this.exhibitionName = null;
      this.$emit("toSearch", this.exhibitionState, this.exhibitionName);
    },
  },
  created(){
    this.loadData();
  },
};
</script>
<style>
.salary-selsect-post .el-input .el-input__inner,
.salary-selsect-post .el-input__inner{
  width: 270px !important;
}

.salary-selsect .el-input__icon{
  height: 20px;
}
.areaInput .el-input__inner{
  width: 100%!important;
}

.order .chance{
  width: 47px;
  height: 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  margin: 0 40px;
  position: relative;
  top: -14px;
  cursor: pointer;
}
.order .chance1{
  width: 47px;
  height: 16px;
  font-family: SourceHanSansCN-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #0071ff;
  margin: 0 40px;
  position: relative;
  top: -14px;
  cursor: pointer;
}

.infoPub .searchBarNode {
  background: #ffffff;
  height: 40px;
  padding: 10px;
}
.infoPub .searchBarNode .el-cascader {
  height: 38px;
  width: 263px;
}
.infoPub .searchBarNode .el-input {
  height: 38px;
  width: 263px;
}
.infoPub .searchBarNode .el-select {
  height: 38px;
  width: 263px;
}
.infoPub .searchBarNode .el-select input {
  width: 263px;
}
.salary-selsect .el-select input {
  width: 270px;
}
.infoPub .searchBarNode .input-with-select {
  border: none;
}
.infoPub .searchBarNode .input-with-interview .el-input__inner {
  width: 560px;
}
.infoPub .searchBarNode .el-input-group__prepend {
  background: #fff !important;
  border: none;
}
.infoPub .searchBarNode .el-input__inner {
  border: 1px solid #e6e6e6;
  /* border-left: none; */
  height: 40px;
  width: 549px;
  border-radius: 5px;
  margin-right: 10px;
}
.infoPub .export .el-input__inner {
  width: 440px;
}
.infoPub .searchBarNode .searchBtn {
  width: 135px;
  height: 40px;
  border-radius: 5px;
  background: #0071ff;
}
/* .infoPub .searchBarNode .el-input-group__append {
  background: #003f8f;
  border-top: 1px solid #003f8f;
  border-bottom: 1px solid #003f8f;
} */
.searchBtn .svg-icon {
  vertical-align: -0.15em !important;
}
</style>
